export enum RunwayEndpoint {
    ForgotPassword = 'api/forgotPassword',
}
